import { render, staticRenderFns } from "./StudentGreatWork.vue?vue&type=template&id=3aa16efa&scoped=true"
import script from "./StudentGreatWork.vue?vue&type=script&lang=js"
export * from "./StudentGreatWork.vue?vue&type=script&lang=js"
import style0 from "./StudentGreatWork.vue?vue&type=style&index=0&id=3aa16efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa16efa",
  null
  
)

export default component.exports